<template>
  <div style="width:100%;float:left;">

    <div v-if="downloadLoading" class="download-overlay">
        <div class="download-box">
            <i class="fa fa-spinner fa-spin fa-3x"></i>
            <div class="download-text">
                Preparing invoice download...
            </div>
        </div>
    </div>

    <CCard>
      <CCardBody>
        <div class="row">
          <!-- <CButton size="sm" color="default" @click="getData()">Refresh</CButton> -->
          <div style="width:100%;float:left;">
            <div style="width:50%;float:left;text-align:center;">Start Date
              <input type="date" v-model="startDate" style="float:left;" class="form-control" />
            </div>
            <div style="width:50%;float:left;text-align:center;">End Date
              <input type="date" v-model="endDate" style="float:left;" class="form-control" />
            </div>
            <!-- <input type="checkbox" v-model="showAll" @change="getOrders()"> Show All (not only open orders)</input> -->
          </div>
          <div style="width:100%;float:right;text-align:center;">
            <CButton size="sm" color="success" class="mt-1" @click="getData()">Search</CButton>
          </div>
          <div class="col-12 float-left" v-if="!loading">
            <center><CButton size="sm" color="info" class="mt-2" @click="downloadCSV">Download CSV</CButton></center>
            <center><CButton size="sm" color="success" class="mt-2 ml-2 mb-4" @click="downloadSelectedInvoices">Download Selected Invoices</CButton></center>
            <CDataTable
              v-if="data"
              :items="data"
              :fields="fields"
              column-filter
              table-filter
              sorter
            >
              <template #selected="{item}">
                <td>
                  <input
                    type="checkbox"
                    v-model="item.selected"
                  >
                </td>
              </template>
              <template #invoice_number="{item}">
                <td>
                  <CLink class="font-weight-bold font-xs btn-block" @click="popupModal(item)">{{item.invoice_number}}</CLink>
                </td>
              </template>
              <template #po_number="{item}">
                <td>
                  {{item.po_number ? item.po_number : ''}}
                </td>
              </template>
              <template #total_dollars="{item}">
                <td>
                  {{ formatCurrency(item.total_dollars) }}
                </td>
              </template>
              <template #resend="{item}">
                <td>
                  <CButton size="sm" :disabled="invoiceLoading" color="info" @click="resendInvoice(item)">Resend Email</CButton>
                </td>
              </template>
              <!-- <template #delete="{item}">
                <td>
                  <CButton size="sm" v-if="you!=item.id" color="danger" @click="deleteUser( item.id )">Delete</CButton>
                </td>
              </template> -->
            </CDataTable>
            <div class="all text-center" v-else>
              Looks like there are no invoices for this customer.
            </div>
          </div>
          <small-loader v-else />
        </div>
      </CCardBody>
    </CCard>

    <!-- <CModal
      title="Invoice"
      :show.sync="modal"
    >
      <div style="width:100%;float:left;"> -->
        <customer-invoice v-if="invoiceData && modal" @close="invoiceData = null, modal = false" :customer_selected="customer_selected" :invoiceData="invoiceData"></customer-invoice>
      <!-- </div> -->
      <!-- <template #footer>
        <CButton @click="invoiceData = '', modal = false" color="success">Close</CButton>
      </template>
    </CModal> -->
    <big-loader v-if="invoiceLoading"></big-loader>

  </div>
</template>
<script>
import CustomerInvoice from './customer_invoice'
var methods = {}

methods.popupModal = function (item) {
  console.log(item)
  this.invoiceData = item
  this.modal = true
}

methods.getData = function () {
  this.loading = true
  const postData = {
    customer: this.customer_selected,
    startDate: this.startDate,
    endDate: this.endDate
  }
  console.log('customer')
  console.log(postData)
  axios.post(this.$apiAdress + '/api/reports/getCustomerInvoices?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.data = response.data.items
    var that = this
    this.data = this.data.map(order => ({
      ...order,
      // units: parseInt(order.units), // Ensure price is a number
      total_dollars: parseFloat(order.total_dollars, 10), // Ensure order_id is an integer
      // total_dollars: that.formatCurrency(order),
      // order_date: that.formatDate(new Date(order.order_date)), // Ensure order_date is a Date object
      invoice_date: that.formatDate(new Date(order.invoice_date)),
      selected: false,
    }));
    this.loading = false
  })
}

methods.formatDate = function (date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

methods.formatCurrency = function (item) {
  return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(item);
}

methods.resendInvoice = function (item) {
  const postData = {
    invoiceData: item
  }
  this.invoiceLoading = true
  axios.post(this.$apiAdress + '/api/reports/resendCustomerInvoice?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.invoiceLoading = false
    Swal.fire(
      'Success',
      'Invoice email resent successfully.',
      'success'
    )
  }).catch(e => {
    this.invoiceLoading = false
    Swal.fire(
      'Success',
      'Invoice email resent successfully.',
      'success'
    )
  })
}

methods.downloadCSV = function () {
  if (!this.data || this.data.length === 0) return;

  const headers = this.fields.map(f => typeof f === 'string' ? f : f.key);
  const csvRows = [];

  // Add header row
  csvRows.push(headers.join(','));

  // Add data rows
  for (const item of this.data) {
    const row = headers.map(field => {
      let val = item[field] !== undefined ? item[field] : '';
      if (typeof val === 'string') {
        val = val.replace(/"/g, '""'); // Escape quotes
        val = `"${val}"`; // Wrap in quotes
      }
      return val;
    });
    csvRows.push(row.join(','));
  }

  // Download it
  const blob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `customer_invoices_${Date.now()}.csv`;
  a.click();
  window.URL.revokeObjectURL(url);
}

methods.downloadSelectedInvoices = function () {
  const invoices = this.data
    .filter(order => order.selected)
    .map(order => ({
        invoice_number: order.invoice_number
    }))

  console.log('current onvoices selected', invoices)

  if (!invoices.length) return

  this.downloadLoading = true

  axios({
      method: 'post',
      url: this.$apiAdress + '/api/reports/downloadSelectedInvoices?token=' + localStorage.getItem('api_token'),
      data: {
          invoices: invoices
      },
      responseType: 'arraybuffer'
  })
  .then((response) => {
      console.log('downloadSelectedInvoices RESponsEE', response)
      const url = window.URL.createObjectURL(new Blob([response.data]))

      const link = document.createElement('a')
      link.href = url
      // const today = new Date().toISOString().slice(0, 10)

      const fileName =
          `${this.customer_selected.customer_name} - invoices.zip`

      link.setAttribute('download', fileName)

      document.body.appendChild(link)
      link.click()
      link.remove()

      window.URL.revokeObjectURL(url)
  }).catch((error) => {
    console.log(error)
  })
  .finally(() => {
    this.downloadLoading = false
  })
}

export default {
  // ===Component name
  name: "CustomerInvoices",
  // ===Props passed to component
  props: ['customer_selected'],
  // ===Components used by this component
  components: {
    CustomerInvoice
  },
  // ====component Data properties
  data(){
      return{
        data: '',
        fields: [
            'invoice_date',
            {
                key: 'selected',
                label: '',
                sorter: false,
                filter: false
            },
            'invoice_number',
            'po_number',
            'so_number',
            'log_number',
            'units',
            'total_dollars',
            'invoice_status',
            'resend'
        ],
        invoiceData: '',
        modal: false,
        loading: true,
        startDate: '',
        endDate: '',
        invoiceLoading: false,
        downloadLoading: false,
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    this.getData()
  },
  // ===Computed properties for the component
  computed: {},
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped lang="scss">
  .bigLabel {
    font-size:18px;
  }
  .bold {
    font-weight: 800;
  }
  .data {
    font-weight: 800;
  }
  .tag {
    padding-left: 20px;
  }
  .tag, .data {
    margin-bottom: 7px;
    font-size: 14px;
  }
  .number {
    text-align: right;
  }
  .download-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255,255,255,.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.download-box {
    text-align: center;
}

.download-text {
    margin-top: 15px;
    font-size: 16px;
    font-weight: 600;
}
</style>
